import getClientConfig from '../config';
import { radiusAuthHeader, logoutRadius } from './radiusAuth';

export const { API_BASE_URL } = getClientConfig(); // e.g. http://localhost:8080/api
const BASE = `${API_BASE_URL}/radius`;

async function handleResponse(res) {
  // Try JSON first; fall back to text
  let data = null;
  try {
    data = await res.json();
  } catch {
    try {
      const text = await res.text();
      data = text ? { message: text } : {};
    } catch {
      data = {};
    }
  }

  if (!res.ok) {
    const msg = data?.message || data?.error || `Request failed (${res.status})`;
    throw new Error(msg);
  }
  return data;
}

// ---------- PUBLIC AUTH ----------
export async function radiusLogin({ username, password }) {
  const res = await fetch(`${BASE}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...radiusAuthHeader(),
    },
    body: JSON.stringify({ username, password }),
  });
  return handleResponse(res);
}

// Optional (available on your backend):
export async function radiusAdminLogin(body) {
  const res = await fetch(`${BASE}/admin-login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...radiusAuthHeader(),
    },
    body: JSON.stringify(body || {}),
  });
  return handleResponse(res);
}
export async function resellerLogin(body) {
  const res = await fetch(`${BASE}/reseller-login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...radiusAuthHeader(),
    },
    body: JSON.stringify(body || {}),
  });
  return handleResponse(res);
}

// ---------- AUTHENTICATED HELPERS ----------
export async function getRadius(path, opts = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method: 'GET',
    headers: {
      // No 'Content-Type' on GET (avoids CORS preflight)
      ...radiusAuthHeader(),
      ...(opts.headers || {}),
    },
  });
  if (res.status === 401);
  return handleResponse(res);
}

export async function deleteRadius(path, opts = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method: 'DELETE',
    headers: {
      // No 'Content-Type' on DELETE (avoids CORS preflight)
      ...radiusAuthHeader(),
      ...(opts.headers || {}),
    },
  });
  if (res.status === 401);
  return handleResponse(res);
}

export async function postRadius(path, body = {}, opts = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...radiusAuthHeader(),
      ...(opts.headers || {}),
    },
    body: JSON.stringify(body),
  });
  if (res.status === 401) ;
  return handleResponse(res);
}

export async function putRadius(path, body = {}, opts = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...radiusAuthHeader(),
      ...(opts.headers || {}),
    },
    body: JSON.stringify(body),
  });
  if (res.status === 401);
  return handleResponse(res);
}
